<template lang="pug">
.v-collections.collections(v-if="data && data.items" :id="data?.id")
	v-loader(:loading="loading")
	.collections__title(v-if="active?.title") {{active.title}}
	.collections__tabs.tags(v-if="data.items.length > 1")
		.tags__items
			.tags__item(v-for="tab in data.items" :class="tab.id === active.id ? 'active' : ''" @click="active = tab") {{tab.title}}
	.collections__items(v-if="active.items")
		.collections__item(v-for="(item, i) in active.items" @mouseenter="active.items[i].open = true" @mouseleave="active.items[i].open = false" :style="{'backgroundColor': item.background}")
			img.collections__item-bg(v-if="item.image" :src="item.image.src" :alt="item.image.alt")
			img.collections__item-icon(:src="item.icon")
			a.cover-link(v-if="item.link" :href="item.link") {{item.title}}
			.collections__item-content
				.collections__item-title(v-if="item.title") {{item.title}}
				v-collapse(:open="item.open")
					.collections__item-body
						.collections__item-text(v-if="item.text") {{item.text}}
						a.collections__item-action.btn.btn--magenta.btn--sm(v-if="item.action" :href="item.action.link") {{item.action.text}}
	.collections__navigate(v-if="!lastPage")
		button.btn.btn--gray(@click="navigate") {{data.navigateText}}
			v-svg-icon.btn__arrow(icon="select-arrow")
</template>

<script>

import sourceMixin from "./mixins/v-mixin-source.vue";
import isMobMixin from "./mixins/v-mixin-is-mob.vue";

export default {

	mixins: [
		sourceMixin,
		isMobMixin
	],

	data() {
		return {
			active: null,
			data: null,
			loading: false
		}
	},

	computed: {
		lastPage() {
			return Math.ceil(this.active.page.count / this.active.page.limit) ===  Math.ceil(this.active.page.offset / this.active.page.limit) + 1;
		}
	},

	methods: {
		dataSet(data, options = {}) {
			if (options.append) {
				let index = this.data?.items?.findIndex(item => item.id === this.active.id);
				if (this.data.items[index] && data.items) {
					this.data.items[index].items = [...this.data.items[index].items, ...data.items];
					this.active.page = data.page;
					this.active = this.data.items[index];
				}
				return;
			}
			this.data = data;
			this.active = this.data?.items?.find(item => item.active) || this.data?.items[0];
		},

		requestDataLoad(dataSetOptions) {
			this.dataLoad({
				url: this.active.remote,
				delay: true,
				data: {
					page: dataSetOptions.page || this.active.page,
					id: this.active.id
				}
			}, dataSetOptions);
		},

		navigate() {
			this.requestDataLoad({append: true, page: {...this.active.page, offset: this.active.page.offset + this.active.page.limit}});
		},
	}
}

</script>